import { ReactNode } from "react";
import { Box, Typography, Link } from "@material-ui/core";

import EELogo from "../../assets/img/efestra-logo.png";

import { useErrorPageStyles } from "./useStyles";

import { coreRoutesConstants } from "modules/core/routes/routesConstants";

interface IProps {
  icon: ReactNode;
  title: string;
  content: ReactNode;
}

const ErrorPage = (props: IProps) => {
  const { icon, title, content } = props;

  const classes = useErrorPageStyles();

  return (
    <Box className={classes.container}>
      <Box className={classes.header}>
        <Link href={coreRoutesConstants.dashboard.href("all")}>
          <img src={EELogo} alt="Efestra" className={classes.logo} />
        </Link>
      </Box>

      <Box className={classes.content}>
        <Box className={classes.icon}>{icon}</Box>

        <Typography variant="h4" className={classes.title}>
          {title}
        </Typography>

        <Box>{content}</Box>
      </Box>
    </Box>
  );
};

export default ErrorPage;
